import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { translationKeys } from '../../../sharedTranslationKeys';
import { TableColumnConfiguration } from '../avano-table.model';

export interface ColumnVisibilityTriggeredEvent {
  newVisibility: boolean;
  columnField: string;
}

@Component({
  selector: 'avano-table-settings',
  templateUrl: './avano-table-settings.component.html',
  styleUrls: ['./avano-table-settings.component.scss']
})
export class AvanoTableSettingsComponent implements OnDestroy {
  private destroyed$ = new Subject();
  private rowsPerPageChangeDebouncer = new Subject<number>();
  tableSettingsTranslationKeys = translationKeys.AvanoTable.Settings;

  @Input() showRowsPerPageSettings = false;
  @Input() rowsPerPageSelection: number[] = [5, 10, 25, 50, 100, 500];
  
  @Input() columnConfigurations: TableColumnConfiguration[];
  @Output() columnVisibilityTriggered: EventEmitter<ColumnVisibilityTriggeredEvent> = new EventEmitter();

  @Output() resetTableTriggered: EventEmitter<void> = new EventEmitter();

  private _rowsPerPage = 50;
  @Input()
  set rowsPerPage(newRowsPerPage: number) {
    if (newRowsPerPage !== this._rowsPerPage) {
      this._rowsPerPage = newRowsPerPage;
      this.rowsPerPageChangeDebouncer.next(newRowsPerPage);
    }
  }
  get rowsPerPage() { return this._rowsPerPage; }
  @Output() rowsPerPageChange: EventEmitter<number> = new EventEmitter();

  public filteredRowsPerPageOptions: string[];

  constructor() {
    this.rowsPerPageChangeDebouncer.pipe(debounceTime(500), takeUntil(this.destroyed$)).subscribe({
      next: newRowsPerPage => this.rowsPerPageChange.emit(newRowsPerPage)
    })
  }

  changeRowsPerPage(value: string): void{
    const rows = parseInt(value);
    const parsedCorrectly = rows.toString() === value;
    const isValidValue = parsedCorrectly && Number.isFinite(rows) && rows > 0;
    if (isValidValue) {
      this.rowsPerPage = rows;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public rowsPerPageFilter(event: { query: string }) {
    const userSearch = event.query.trim();
    this.filteredRowsPerPageOptions = this.rowsPerPageSelection.filter((singleOption: number) => {
      return singleOption.toString().startsWith(userSearch);
    }).map(x => x.toString());
  }

  public changeColumnVisibility(newVisibility: boolean, columnField: string) {
    this.columnVisibilityTriggered.emit({newVisibility, columnField})
  }

  public resetTableSettings() {
    this.resetTableTriggered.emit();
  }
}
